import { signalStore, withMethods, withState } from '@ngrx/signals';
import { inject } from '@angular/core';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { debounceTime, pipe, switchMap } from 'rxjs';
import { AdsRepository } from '@core/repositories/ads.repository';

type AdsState = {};

const initialAdsState: AdsState = {};

export const AdsStore = signalStore(
  { providedIn: 'root' },
  withState(initialAdsState),
  withMethods((
    state,
    api = inject(AdsRepository),
  ) => ({
    view: rxMethod<{ ads_id: string, duration: number }>(
      pipe(
        debounceTime(10),
        switchMap(({ ads_id, duration }) => api.postView(ads_id, { duration })),
      ),
    ),
    click: rxMethod<{ ads_id: string, duration: number, url: string }>(
      pipe(
        debounceTime(10),
        switchMap(({ ads_id, duration, url }) => api.postClick(ads_id, { duration, url })),
      ),
    ),
  })),
);
